import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	optionPmsActiveListServerData: Type.ServerData.OptionPmsActiveListServerData | undefined;
};
type QueryData = Type.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
type Result = {
	onConvertOptionPmsActiveList: (props: Props) => QueryData | undefined;
};

export const useOptionPmsActiveListConverter = (): Result => {
	/**
	 * QueryData への変換処理
	 */
	const onConvertOptionPmsActiveList = useCallback(
		({ optionPmsActiveListServerData }: Props): QueryData | undefined => {
			if (!optionPmsActiveListServerData) return undefined;

			return {
				optionPmsList: {
					id: optionPmsActiveListServerData.optionPmsActiveList.id,
					options: optionPmsActiveListServerData.optionPmsActiveList.options.map((option) => ({
						id: option.id,
						hotelID: option.hotelID,
						itemType: option.itemType,
						reservationID: option.reservationID,
						uniqueID: option.uniqueID,
						cardID: option.uniqueID,
						date: option.date,
						guestName: option.guestName,
						guestTel: option.guestTel ?? undefined,
						optionID: option.optionID,
						/**
						 * subOption に関連するデータは無いケースが自明としてあるので、null とする
						 */
						subOptionID: option.subOptionID ?? null,
						optionName: option.optionName,
						/**
						 * subOption に関連するデータは無いケースが自明としてあるので、null とする
						 */
						subOptionName: option.subOptionName ?? undefined,
						amount: option.amount,
						optionStartAt: option.optionStartAt,
						optionEndAt: option.optionEndAt,
						paymentMethod: option.paymentMethod,
						planName: option.planName ?? undefined,
						memo: option.memo ?? undefined,
						canDelete: option.canDelete,
						roomNum: option.roomNum?.map((roomNum) => ({
							adultNum: roomNum.adultNum,
							uniqueRoomID: roomNum.uniqueRoomID,
							kidsNum: roomNum.kidsNum.map((kidsNum) => ({
								age: kidsNum.age,
								asCosleeping: kidsNum.asCosleeping ?? undefined,
							})),
						})),
						questions: option.questions?.map((question) => ({
							question: question.question,
							answer: question.answer,
						})),
					})),
				},
			} satisfies QueryData;
		},
		[],
	);

	return {
		onConvertOptionPmsActiveList,
	};
};
